var $ = require('js/sw-jquery/sw-jquery');

/**
 * The material selector on the bottom portion of the left nav in model edit
 *
 * Usage:
 *   data-sw-model-edit-material-selector
 *   Container for the ModelEditMaterialSelector
 *
 */
module.exports = function ($fragment) {

    $fragment.swFindWithSelf('[data-sw-model-edit-material-selector]').each(function () {

        var $el = $(this);
        var modelId = $el.data('swModelEditMaterialSelector');

        require(['js/lib/models/ModelManager', 'js/lib/views/ModelEditMaterialSelector'], function (ModelManager, ModelEditMaterialSelector) {
            ModelManager.amdNewModelEditModel(modelId, function (model) {
                var options = {
                    el: $el,
                    model: model,
                    shapeJsId: 'realMaterialRender'
                };
                new ModelEditMaterialSelector(options);
            });

        });
    });


};
